import { render, staticRenderFns } from "./NavigationOverlay.vue?vue&type=template&id=58e10a22&scoped=true"
import script from "./NavigationOverlay.vue?vue&type=script&lang=js"
export * from "./NavigationOverlay.vue?vue&type=script&lang=js"
import style0 from "./NavigationOverlay.vue?vue&type=style&index=0&id=58e10a22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e10a22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58e10a22')) {
      api.createRecord('58e10a22', component.options)
    } else {
      api.reload('58e10a22', component.options)
    }
    module.hot.accept("./NavigationOverlay.vue?vue&type=template&id=58e10a22&scoped=true", function () {
      api.rerender('58e10a22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/Shared/Partials/NavigationOverlay.vue"
export default component.exports